export default __webpack_public_path__ + "static/media/icon-panel-arrow.4841813f.svg";